/**
 * Aside (sidebar) navigation expand/collapse for nested items
 */

const toggles = [...document.querySelectorAll('.js-asideSubmenuToggle')];

toggles.forEach(toggle => {
    toggle.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();

        const parent = toggle.closest('.-hasSubmenu');

        if (!parent) {
            return;
        }

        const expanded = parent.classList.toggle('-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
});
